var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhantom({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 30,
    viewBox: "0 0 36 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7126_16705)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.793945 24.4284C0.793945 28.1984 2.82395 29.0684 4.85395 29.0684C9.20395 29.0684 12.5873 25.2017 14.5206 22.1084C14.3273 22.785 14.1339 23.4617 14.1339 24.1384C14.1339 25.8784 15.1006 27.2317 17.1306 27.2317C19.8373 27.2317 22.8339 24.815 24.2839 22.205C24.1873 22.5917 24.0906 22.9784 24.0906 23.2684C24.0906 24.525 24.7673 25.2984 26.2173 25.2984C30.6639 25.2984 35.1106 17.3717 35.1106 10.315C35.1106 4.90169 32.4039 0.0683594 25.5406 0.0683594C13.7473 0.0683594 0.793945 14.8584 0.793945 24.4284ZM21.5811 9.7326C21.5811 8.37926 22.3544 7.4126 23.4177 7.4126C24.4811 7.4126 25.2544 8.37926 25.2544 9.7326C25.2544 11.0859 24.4811 12.0526 23.4177 12.0526C22.3544 12.0526 21.5811 11.0859 21.5811 9.7326ZM29.1169 7.41504C28.0536 7.41504 27.2803 8.38171 27.2803 9.73504C27.2803 11.0884 28.0536 12.055 29.1169 12.055C30.1803 12.055 30.9536 11.0884 30.9536 9.73504C30.9536 8.38171 30.1803 7.41504 29.1169 7.41504Z",
    fill: "#AB9FF2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7126_16705"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.4133,
    height: 29,
    fill: "white",
    transform: "translate(0.793945 0.0683594)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhantom);
export default __webpack_public_path__ + "static/media/phantom.0501bb81e135feb0b719a03b13998d4b.svg";
export { ForwardRef as ReactComponent };